export const SegmentType = {
    STATIC: 'static',
    AUTO_REFRESH: 'auto_refresh',
} as const;

export const SegmentTypeToLabel = {
    [SegmentType.STATIC]: 'Static',
    [SegmentType.AUTO_REFRESH]: 'Auto-refreshing',
};

export type SegmentAudienceType = 'marketing' | 'transactional' | 'acquisition' | 're_acquisition';
export type SegmentRefreshType = (typeof SegmentType)[keyof typeof SegmentType];
export type SegmentSortField = 'id' | 'name';
